// Blog SEO Kalypso Music : 30 articles bilingues FR/EN organisés en 8 cocons sémantiques
// (mariage, anniversaire, naissance/famille, amour, hommage, fêtes/occasions, guides, comparatifs).
// Chaque cocon embarque des chansons d'exemple réellement générées par la plateforme,
// servies par /api/public/blog-song/{id}/audio.
import { COCON_MARIAGE } from "./blog/coconMariage";
import { COCON_ANNIVERSAIRE } from "./blog/coconAnniversaire";
import { COCON_NAISSANCE } from "./blog/coconNaissance";
import { COCON_AMOUR } from "./blog/coconAmour";
import { COCON_HOMMAGE } from "./blog/coconHommage";
import { COCON_FETES } from "./blog/coconFetes";
import { COCON_GUIDES } from "./blog/coconGuides";
import { COCON_COMPARATIFS } from "./blog/coconComparatifs";

export const BLOG_ARTICLES = [
  ...COCON_MARIAGE,
  ...COCON_ANNIVERSAIRE,
  ...COCON_NAISSANCE,
  ...COCON_AMOUR,
  ...COCON_HOMMAGE,
  ...COCON_FETES,
  ...COCON_GUIDES,
  ...COCON_COMPARATIFS,
];
